<template>
  <div>
    <v-dialog v-model="customersDialog" max-width="900">
      <Customers
        :deleteButton="false"
        :editButton="false"
        :selectButton="true"
        :refresh="false"
        :selectCell="selectCustomer"
      />
    </v-dialog>
    <v-dialog v-model="detailDialog" max-width="900px">
      <v-card>
        <v-toolbar dark color="teal">
          <v-btn icon dark @click="detailDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Battery Detail</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="dialog = false"
              v-exporttocsv="'#createdbattery'"
            >
              <v-icon small>save</v-icon> Download
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-simple-table class="dialog-no-footer" id="createdbattery">
          <template v-slot:default>
            <thead>
              <tr>
                <th>#</th>
                <th>Value</th>
                <th>Power</th>
                <th>Power / Value</th>
                <th>#</th>
                <th>Value</th>
                <th>Power</th>
                <th>Power / Value</th>
                <th>Total Power / Value</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(battery, i) in batteryDetail.cells" :key="i">
                <td>{{ battery.cells[0].number }}</td>
                <td>{{ battery.cells[0].value }}</td>
                <td>{{ battery.cells[0].power }}</td>
                <td>{{ battery.cells[0].pov }}</td>
                <td>{{ battery.cells[1].number }}</td>
                <td>{{ battery.cells[1].value }}</td>
                <td>{{ battery.cells[1].power }}</td>
                <td>{{ battery.cells[1].pov }}</td>
                <td>{{ battery.pov }}</td>
              </tr>

              <tr>
                <td colspan="9"></td>
              </tr>

              <tr>
                <td colspan="6">
                  <tr colspan="6">
                    <th colspan="1"></th>
                    <th colspan="10">Cells In Battery Not Found</th>
                    <th colspan="1"></th>
                  </tr>

                  <tr>
                    <th>ID</th>
                    <th>Value</th>
                    <th>Power</th>
                    <th>Power / Value</th>
                    <th>#</th>
                  </tr>
                  <tr v-for="(battery, i) in not_in_battery" :key="i">
                    <td>{{ battery.number }}</td>
                    <td>{{ battery.value }}</td>
                    <td>{{ battery.power }}</td>
                    <td>{{ battery.pov }}</td>
                    <td></td>
                  </tr>
                </td>
                <td colspan="6">
                  <tr colspan="6">
                    <th colspan="1"></th>
                    <th colspan="10">Cells Not Found In Battery</th>
                    <th colspan="1"></th>
                    <th></th>
                  </tr>

                  <tr>
                    <th>ID</th>
                    <th>Value</th>
                    <th>Power</th>
                    <th>Power / Value</th>
                    <th>#</th>
                  </tr>
                  <tr v-for="(battery, i) in battery_cell" :key="i">
                    <td>{{ battery.number }}</td>
                    <td>{{ battery.value }}</td>
                    <td>{{ battery.power }}</td>
                    <td>{{ battery.pov }}</td>
                    <td></td>
                  </tr>
                </td>
              </tr>

              <tr>
                <td colspan="9"></td>
              </tr>
              <!-- <tr>
                <th colspan="4"></th>
                <th colspan="4">Cells In Battery Not Found</th>
                <th colspan="4"></th>
                <th></th>
              </tr>
              <tr>
                <th colspan="2">ID</th>
                <th colspan="2">Cell</th>
                <th colspan="2">name</th>
                <th></th>
              </tr> -->
              <!-- <tr
                v-for="(battery, i) in batteryMeta.batteryStrength"
                :key="`meta-${i}`"
              >
                <td colspan="2">{{ battery.name }}</td>
                <td colspan="2">{{ battery.max }}</td>
                <td colspan="2">{{ battery.min }}</td>
                <td colspan="2">{{ (battery.max - battery.min) | number }}</td>
                <td></td>
              </tr> -->

              <tr>
                <td colspan="9"></td>
              </tr>
              <tr>
                <td colspan="9"></td>
              </tr>
              <tr>
                <th colspan="2"></th>
                <th colspan="2">Max</th>
                <th colspan="2">Min</th>
                <th colspan="2">Difference</th>
                <th></th>
              </tr>
              <tr
                v-for="(battery, i) in batteryMeta.batteryStrength"
                :key="`meta-${i}`"
              >
                <td colspan="2">{{ battery.name }}</td>
                <td colspan="2">{{ battery.max }}</td>
                <td colspan="2">{{ battery.min }}</td>
                <td colspan="2">{{ (battery.max - battery.min) | number }}</td>
                <td></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-dialog>
    <v-dialog v-model="qrCodeDialog" content-class="auto-w">
      <v-card>
        <QRCode :value="qrCodeData" />
      </v-card>
    </v-dialog>

    <v-tabs>
      <v-tabs-slider></v-tabs-slider>

      <v-tab>Not Assigned</v-tab>
      <v-tab>All</v-tab>

      <v-tab-item>
        <v-card>
          <v-data-table
            :headers="ubHeaders"
            :items="uninstalledBatteries"
            :loading="loading"
            :server-items-length="totalUninstalledBatteries"
            :options.sync="ubOptions"
          >
            <template v-slot:item.dated="{ item }">
              {{ $date.utcToLocal(item.dated) }}
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn text @click="viewItem(item)" class="mr-1">
                <v-icon small>remove_red_eye</v-icon> View
              </v-btn>
              <v-btn text @click="assignItem(item)" class="mr-1">
                <v-icon small>assignment</v-icon> Assign
              </v-btn>
              <v-btn text @click="editItem(item)" class="mr-1">
                <v-icon small>edit</v-icon> Edit
              </v-btn>
              <v-btn text @click="deleteUBattery(item)" color="red">
                <v-icon small>delete</v-icon> Delete
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card>
          <v-data-table
            :headers="bHeaders"
            :items="allBatteries"
            :loading="loading"
            :server-items-length="totalUninstalledBatteries"
            :options.sync="bOptions"
          >
            <template v-slot:item.dated="{ item }">
              {{ $date.utcToLocal(item.dated) }}
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn text @click="viewItem(item)" class="mr-1">
                <v-icon small>remove_red_eye</v-icon> View
              </v-btn>
              <v-btn
                text
                @click="assignItem(item)"
                class="mr-1"
                v-if="item.installed === 1"
              >
                <v-icon small>assignment</v-icon> Re-Assign
              </v-btn>
              <v-btn
                text
                @click="viewQrCode(item)"
                class="mr-1"
                color="blue"
                v-if="item.installed === 1"
              >
                <v-icon small>qr_code</v-icon> View Qr Code
              </v-btn>
              <v-btn
                text
                @click="assignItem(item)"
                class="mr-1"
                v-if="item.installed === 0"
              >
                <v-icon small>assignment</v-icon> Assign
              </v-btn>
              <v-btn
                text
                @click="deleteABattery(item)"
                color="red"
                v-if="item.installed === 0"
              >
                <v-icon small>delete</v-icon> Delete
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import api from "@/api";
import Customers from "../customers/Customers.vue";
import QRCode from "../QRCode.vue";
import { useArrayDifference } from "@vueuse/core";

export default {
  name: "Batteries",
  components: {
    Customers,
    QRCode,
  },
  data: () => ({
    qrCodeDialog: false,
    qrCodeData: "",
    dialog: false,
    loading: false,
    ubOptions: {},
    selectedFilter: ["number", "balanced"],
    bOptions: {},
    ui_cells: "",
    battery_cell: "",
    not_in_battery: "",
    ubHeaders: [
      {
        text: "#",
        align: "left",
        sortable: false,
        value: "id",
      },
      { text: "Created On", value: "dated" },
      { text: "Actions", value: "action", sortable: false },
    ],
    bHeaders: [
      {
        text: "#",
        align: "left",
        sortable: false,
        value: "id",
      },
      { text: "Created On", value: "dated" },
      { text: "Vin", value: "vin" },
      { text: "Actions", value: "action", sortable: false },
    ],
    allBatteries: [],
    totalBatteries: 0,
    uninstalledBatteries: [],
    totalUninstalledBatteries: 0,
    editedIndex: -1,
    editedItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    defaultItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    search: "",
    detailDialog: false,
    batteryDetail: {
      cells: [],
    },
    batteryMeta: {
      batteryStrength: [],
    },
    customersDialog: false,
    assigningItem: {},
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },
  filters: {
    number: function (value) {
      if (!value) return "";
      value = value.toFixed(2);
      return value;
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    ubOptions: {
      handler() {
        this.getUninstallBatteries();
      },
      deep: true,
    },
    bOptions: {
      handler() {
        this.getAllBatteries();
      },
      deep: true,
    },
  },
  methods: {
    initialize() {
      this.getAllBatteries();
      this.getUninstallBatteries();
    },

    async getAllBatteries() {
      const { page = 1, itemsPerPage = 10 } = this.bOptions;
      this.loading = true;
      const response = await api.getBatteriesList(
        this.search,
        itemsPerPage,
        page
      );
      this.totalBatteries = response.data.count;
      this.allBatteries = response.data.data;
      this.loading = false;
    },
    async getUninstallBatteries() {
      const { page = 1, itemsPerPage = 10 } = this.ubOptions;
      this.loading = true;
      const response = await api.getBatteriesNotInstalled(itemsPerPage, page);
      this.totalUninstalledBatteries = response.data.count;
      this.uninstalledBatteries = response.data.data;
      this.loading = false;

      const ui_cells = await api.getAvailableCellsList(
        100000,
        1,
        this.search,
        this.selectedFilter
      );
      // this.totalCellList = res.data.count;
      // this.cellList = res.data.data;
      // console.log(totalCellList);

      this.ui_cells = ui_cells.data.data;
      // console.log(this.ui_cells);
      this.loading = false;
    },
    async deleteABattery(item) {
      const deleted = await this.deleteBattery(item);
      if (deleted) {
        this.getAllBatteries();
      }
    },
    async deleteUBattery(item) {
      const deleted = await this.deleteBattery(item);
      if (deleted) {
        this.getUninstallBatteries();
      }
    },
    async deleteBattery(item) {
      const confirm = await this.$alert.confirm(`Delete Battery #${item.id} ?`);
      if (confirm && confirm.value === true) {
        try {
          await api.discardBattery([item.id]);
          this.$toast.success("Deleted Successfully");
          return true;
        } catch (error) {
          this.$toast.error("Error Deleting");
        }
      }
      return false;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    },
    async viewItem(item) {
      try {
        const response = await api.getBattery(item.id);
        const battery = response.data[0];
        battery.cells = JSON.parse(battery.cells);
        this.batteryDetail = battery;
        this.detailDialog = true;
        const cells = [];
        battery.cells.forEach((b) => {
          b.cells.forEach((c) => cells.push(c));
        });
        var payload = {
          cells: cells,
          ui_cells: this.ui_cells,
          battery_id: item.id,
        };
        const res = await api.cellscheck(item.id, payload);
        this.not_in_battery = res.data.battery_diff_cells;
        this.battery_cell = res.data.diff_ui_cells;
        this.batteryMeta = this.$getBatteryMeta(cells);
      } catch (error) {
        this.$toast.error("Error Getting Battery");
      }
    },
    async viewQrCode(item) {
      try {
        const response = await api.getBattery(item.id);
        const battery = response.data[0];
        const cells = JSON.parse(battery.cells);
        const warranty = JSON.parse(battery.warranty).value.replace(/\D/g, "");
        const saleDate = battery.date.replace(/\D/g, "");
        let data = `Battery  ${warranty}${saleDate}${battery.id}\nCells\n`;

        cells.forEach((pair) => {
          pair.cells.forEach((cell) => {
            data += `${cell.number}\n`;
          });
        });

        this.qrCodeDialog = true;
        this.qrCodeData = data;
      } catch (error) {
        this.$toast.error("Error Getting Battery");
      }
    },
    editItem(item) {
      this.$router.push(`batteries/${item.id}`);
    },
    assignItem(item) {
      this.assigningItem = item;
      this.customersDialog = true;
    },
    async selectCustomer(customer) {
      try {
        await api.assignCustomerBattery(customer.id, this.assigningItem.id);
        this.initialize();
        this.$toast.success("Battery Assigned");
      } catch (error) {
        this.$toast.error("Error");
      }
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>